function getEnvironmentVariable(name: string) {
  return typeof process !== "undefined" && process.env?.[name]
    ? process.env[name]
    : import.meta.env[name];
}

export const PORT: number = Number(getEnvironmentVariable("PORT") ?? 8080);

export const IS_CHROME_EXTENSION =
  window.location.protocol === "chrome-extension:";

export const IS_TEST = process.env.NODE_ENV === "test";

export const IS_IN_IFRAME = window.parent !== window;

function getServiceUrl(useLocalhostServer: boolean = false): string {
  if (IS_TEST) {
    return window.location.origin;
  }

  if (useLocalhostServer) {
    return `http://localhost:${PORT}`;
  }

  const serviceUrl = getEnvironmentVariable("VITE_SERVICE_URL");

  if (serviceUrl) {
    return serviceUrl;
  }

  if (getEnvironmentVariable("STORYBOOK") === "true") {
    return "http://localhost:6009";
  }

  return window.location.origin;
}

export const DEV_LOGIN_EMAIL: string | undefined = getEnvironmentVariable(
  "VITE_DEV_LOGIN_EMAIL",
);

export const DEV_LOGIN_PASSWORD: string | undefined = getEnvironmentVariable(
  "VITE_DEV_LOGIN_PASSWORD",
);

export const MOCKING_ENABLED =
  getEnvironmentVariable("VITE_MOCKING_ENABLED") === "true";

export const APP_VERSION: string =
  getEnvironmentVariable("VITE_APP_VERSION") ?? "0.0.0-development";

export const APP_ENV: string =
  getEnvironmentVariable("VITE_APP_ENV") ?? "development";

export const CDN_ASSET_URL: string | undefined =
  getEnvironmentVariable("VITE_CDN_ASSET_URL");

export const SERVICE_URL: string = getServiceUrl();

export const DATADOG_CLIENT_TOKEN: string | undefined = getEnvironmentVariable(
  "VITE_DATADOG_CLIENT_TOKEN",
);

export const DATADOG_SITE: string =
  getEnvironmentVariable("VITE_DATADOG_SITE") ?? "datadoghq.com";

export const DATADOG_SERVICE: string =
  getEnvironmentVariable("VITE_DATADOG_SERVICE") ?? "stitch-web";

export const DATADOG_RUM_APPLICATION_ID: string | undefined =
  getEnvironmentVariable("VITE_DATADOG_RUM_APPLICATION_ID");

const IS_PRODUCTION = APP_ENV === "production";

function getStitchApiUrl(): string {
  if (MOCKING_ENABLED) {
    return window.location.origin + "/gw/stitch-api";
  }

  const viteStitchApiUrl = getEnvironmentVariable("VITE_STITCH_API_URL");

  if (viteStitchApiUrl) {
    return viteStitchApiUrl;
  }

  switch (APP_ENV) {
    case "development":
      return "https://stitch-api-dev.el8-dev-services.internal/";
    case "stage":
      return "https://stitch-api-stage.el8-stage-services.internal/";
    case "sandbox":
      return "https://stitch-api-sandbox.el8-sandbox-services.internal/";
    case "production":
      return "https://stitch-api-production.el8-production-services.internal/";
  }

  return "https://stitch-api-dev.el8-dev-services.internal/";
}

export const STITCH_API_URL: string = getStitchApiUrl();

export const OKTA_DISCOVERY_URL: string =
  getEnvironmentVariable("VITE_OKTA_DISCOVERY_URL") ??
  (IS_PRODUCTION
    ? "https://sso.elationemr.com/oauth2/aus3qzcn4bVk5ZbDq5d7"
    : "https://sso.dev.elationemr.com/oauth2/aus28i02wjsXMO79U1d7");

export const OKTA_CLIENT_ID: string =
  getEnvironmentVariable("VITE_OKTA_CLIENT_ID") ??
  (IS_PRODUCTION ? "to-be-determined" : "0oaseeentiVrL97PG1d7");

export const OKTA_SCOPES: string[] = [
  "openid",
  "profile",
  "offline_access",
  "email",
  "stitch",
];

const environment = {
  DEV_LOGIN_EMAIL,
  DEV_LOGIN_PASSWORD,
  MOCKING_ENABLED,
  APP_VERSION,
  PORT,
  CDN_ASSET_URL,
  SERVICE_URL,
  IS_CHROME_EXTENSION,
  OKTA_DISCOVERY_URL,
  OKTA_CLIENT_ID,
  OKTA_SCOPES,
  STITCH_API_URL,
  DATADOG_CLIENT_TOKEN,
  DATADOG_SITE,
  DATADOG_SERVICE,
  DATADOG_RUM_APPLICATION_ID,
};

export default environment;
